import { combineReducers } from 'redux';

import user from './userReducer';
import loading from './loadingReducer';
import notes from './notesReducer';
import trip from './tripReducer';
import vehicle from './vehicleReducer';
import parties from './partiesReducer';
import payments from './paymentsReducer';
import fastag from './fastagReducer';
import expenses from './expensesReducer';

const rootReducer = combineReducers({ user, loading, notes, trip, vehicle,parties, payments, fastag,expenses});

export default rootReducer;